export interface Literals {
  [key: string]: { es: string; en: string };
}

const literals: Literals = {
  actives: {
    es: "Activas",
    en: "Actives",
  },
  aProblem: {
    es: "Ha habido un problema",
    en: "There was a problem",
  },
  black: {
    es: "Negro",
    en: "Black",
  },
  cancel: {
    es: "Cancelar",
    en: "Cancel",
  },
  carIndicated: {
    es: "El carro es el que indica CS/PMO",
    en: "The car is the one indicated by CS/PMO",
  },
  carNumber: {
    es: "Número de carro",
    en: "Car number",
  },
  ccInspection: {
    es: "Inspección CC",
    en: "CC Inspection",
  },
  checklist: {
    es: "Checklist",
    en: "Checklist",
  },
  closed: {
    es: "Cerradas",
    en: "Closed",
  },
  colour: {
    es: "Color",
    en: "Colour",
  },
  cradleNumber: {
    es: "NS Cuna",
    en: "Cradle number",
  },
  createNewInspection: {
    es: "Crear nueva inspección",
    en: "Create new inspection",
  },
  endDate: {
    es: "Fecha de finalización",
    en: "End Date",
  },
  engineType: {
    es: "Tipo de motor",
    en: "Engine Type",
  },
  esnEnter: {
    es: "ESN Entrada",
    en: "Enter ESN",
  },
  date: {
    es: "Fecha",
    en: "Date",
  },
  esnEntry: {
    es: "ESN Entrada",
    en: "ESN Entry",
  },
  esnExit: {
    es: "ESN Salida",
    en: "Exit ESN",
  },
  disassemblyInspection: {
    es: "Inspección de desmontaje",
    en: "Disassembly inspection",
  },
  filter: {
    es: "Filtrar",
    en: "Filter",
  },
  goToInspection: {
    es: "Ir a la inspección",
    en: "Go to inspection",
  },
  inspectionsForThisCar: {
    es: "El carro [data{0}] ya tiene una inspección iniciada.",
    en: "Stand [data{0}] already has an opened inspection.",
  },
  inspections: {
    es: "Inspecciones",
    en: "Inspections",
  },
  inspectionsList: {
    es: "Listado de inspecciones",
    en: "Inspections list",
  },
  invalidOrFutureDate: {
    es: "Fecha inválida o futura. Usa dd/mm/yyyy",
    en: "Invalid or future date. Use dd/mm/yyyy format.",
  },
  loading: {
    es: "Cargando",
    en: "Loading",
  },
  mdpInspection: {
    es: "Inspección MdP",
    en: "MdP Inspection",
  },
  newInspection: {
    es: "Nueva inspección",
    en: "New inspection",
  },
  next: {
    es: "Siguiente",
    en: "Next",
  },
  noInspectionsForThisCar: {
    es: "No hay una inspección vigente para este carro.",
    en: "There is no opened inspection for this stand.",
  },
  noPossibleInformation: {
    es: "No ha sido posible obtener la información solicitada. Por favor, inténtalo más tarde.",
    en: "The requested information could not be retrieved. Please try again later.",
  },
  owner: {
    es: "Propietario",
    en: "Owner",
  },
  phase: {
    es: "Fase",
    en: "Phase",
  },
  preChecks: {
    es: "Comprobaciones previas",
    en: "Pre-checks",
  },
  previous: {
    es: "Anterior",
    en: "Previous",
  },
  project: {
    es: "Proyecto",
    en: "Project",
  },
  red: {
    es: "Rojo",
    en: "Red",
  },
  required: {
    es: "Campo obligatorio",
    en: "Required field",
  },
  search: {
    es: "Buscar",
    en: "Search",
  },
  searchPlaceholder: {
    es: "Busca por tipo de motor, ESN...",
    en: "Search by engine type, ESN...",
  },
  snStand: {
    es: "SN Carro",
    en: "Stand SN",
  },
  startDate: {
    es: "Fecha de inicio",
    en: "Start date",
  },
  users: {
    es: "Usuarios",
    en: "Users",
  },
  validate: {
    es: "Validar",
    en: "Validate",
  },
  white: {
    es: "Blanco",
    en: "White",
  },
  ready: {
    es: "Listo",
    en: "Ready",
  },
  lastUpdate: {
    es: "Última actualización",
    en: "Last update",
  },
  goBack: {
    es: "Volver",
    en: "Go back",
  },
  edit: {
    es: "Editar",
    en: "Edit",
  },
  saveChanges: {
    es: "Guardar cambios",
    en: "Save changes",
  },
  finishTask: {
    es: "Completar tarea",
    en: "Finish task",
  },
  addDescription: {
    es: "Agrega una descripción",
    en: "Add description",
  },
  addImage: {
    es: "Añadir imagen",
    en: "Add image",
  },
  selectAnswer: {
    es: "Seleccione una respuesta",
    en: "Select an asnwer",
  },
  back: {
    es: "Volver",
    en: "Back",
  },
  engine: {
    es: "Motor",
    en: "Engine",
  },
  error: {
    es: "Error",
    en: "Error",
  },
  esnIn: {
    es: "ESN Entrada",
    en: "ESN Entry",
  },
  esnOut: {
    es: "ESN Salida",
    en: "ESN Exit",
  },
  exportPdf: {
    es: "Exportar PDF",
    en: "Export PDF",
  },
  indicateCsPmo: {
    es: "¿Es CS/PMO?",
    en: "It's CS/PMO?",
  },
  inspectionCreated: {
    es: "La nueva inspección del <strong>carro [data{0}]</strong> ha sido creada correctamente.",
    en: "The new inspection for <strong>stand [data{0}]</strong> has been successfully created.",
  },
  inspectionStand: {
    es: "Inspección carro",
    en: "Inspection stand",
  },
  noPossibleCreateInspection: {
    es: "No se pudo crear la inspección. Intenta nuevamente.",
    en: "The inspection could not be created. Please try again.",
  },
  nsCradle: {
    es: "NS Cuna",
    en: "Cradle number",
  },
  seeLessDetails: {
    es: "Ver menos detalles",
    en: "Show less details",
  },
  seeMoreDetails: {
    es: "Ver más detalles",
    en: "Show more details",
  },
  stand: {
    es: "Carro",
    en: "Stand",
  },
  start: {
    es: "Inicio",
    en: "Start",
  },
  success: {
    es: "¡Éxito!",
    en: "Success!",
  },
  yes: {
    es: "Sí",
    en: "Yes",
  },
  pending: {
    es: "Pendiente",
    en: "Pending",
  },
  blocked: {
    es: "Bloqueada",
    en: "Bloqued",
  },
  addCommentOrImages: {
    es: "Añadir comentario o imágenes",
    en: "Add comments or images",
  },
  inspectionCompleted: {
    es: "Inspección finalizada",
    en: "Inspection completed",
  },
  inspectionDuration: {
    es: "Duración de la inspección",
    en: "Inspection duration",
  },
  inProgress: {
    es: "En progreso",
    en: "In progress",
  },
  tasksCompleted: {
    es: "[data{0}] de [data{1}] tareas",
    en: "[data{0}] fo [data{1}] tasks",
  },
  completed: {
    es: "Completado",
    en: "Completed",
  },
  stageStart: {
    es: "Inicio de fase",
    en: "Start of the phase",
  },
  mdpRepair: {
    es: "Reparación MdP",
    en: "MdP Repair",
  },
  actionDescription: {
    es: "Descripción acción [data{0}]",
    en: "Desciption acction [data{0}]",
  },
  actionToDo: {
    es: "Acción a realizar",
    en: "Action to do",
  },
  phaseHasCompleted: {
    es: "Se ha completado la fase [data{0}]",
    en: "The [data{0}] phase has been completed.",
  },
  closeCurrentPhase: {
    es: "Cierra la fase actual para poder desbloquear la etapa [data{0}].",
    en: "Close the current phase to unlock stage [data{0}].",
  },
  closePhase: {
    es: "Cerrar [data{0}]",
    en: "Close [data{0}]",
  },
  allPhasesCompleted: {
    es: "Todas las fase de la inspección están completas, ya puedes finalizar la inspección.",
    en: "All phases of the inspection are complete, you can now end the inspection.",
  },
  endInspection: {
    es: "Finalizar inspección",
    en: "End inspection",
  },
  noPosibleSaveChange: {
    es: "No ha sido posible guardar los cambios. Por favor, inténtalo más tarde.",
    en: "It was not possible to save the changes. Please try again later.",
  },
  endOfInspection: {
    es: "Finalización de la inspección",
    en: "End of the inspection",
  },
  confirmEndInspection: {
    es: "Al finalizar la inspección no podrá editar ninguna de las acciones que ha realizado, tampoco podrás deshacer esta acción ¿Esta seguro?",
    en: "Once the inspection is complete, you will not be able to edit any of the actions you have taken, nor will you be able to undo this action. Are you sure?",
  },
  action: {
    es: "Acción",
    en: "Acction",
  },
  noOpenInspections: {
    es: "No se ha podido encontrar inspecciones abiertas.",
    en: "Unable to find any open inspections.",
  },
  noClosedInspections: {
    es: "No se ha podido encontrar inspecciones cerradas.",
    en: "Unable to find any closed inspections",
  },
  noSearchResults: {
    es: "No hay resultados que coincidan con los filtros aplicados.",
    en: "No results found for the selected filters.",
  },
  cleanFilters: {
    es: "Borrar filtros",
    en: "Clean filters",
  },
  tasks: {
    es: "Tareas",
    en: "Tasks",
  },
  status: {
    es: "Estado",
    en: "Status",
  },
  actions: {
    es: "Acciones",
    en: "Acctions",
  },
  on: {
    es: "Activo",
    en: "Active",
  },
  off: {
    es: "Inactivo",
    en: "Inactive",
  },
  images: {
    es: "Imágenes",
    en: "Images",
  },
  save: {
    es: "Guardar",
    en: "Save",
  },
  addQuestion: {
    es: "Añadir pregunta",
    en: "Add question",
  },
  questionDescripction: {
    es: "Descripción de la acción",
    en: "Action description",
  },
  spanish: {
    es: "Español",
    en: "Spanish",
  },
  english: {
    es: "Inglés",
    en: "English",
  },
  newQuestion: {
    es: "Nueva pregunta",
    en: "New question",
  },
  editQuestion: {
    es: "Editar pregunta",
    en: "Edit question",
  },
  removeQuestion: {
    es: "Eliminar pregunta",
    en: "Remove question",
  },
  removeQuestionDescription: {
    es: "¿Está seguro que desea eliminar la pregunta [data{0}]?",
    en: "Are you sure you want to delete question [data{0}]?",
  },
  remove: {
    es: "Eliminar",
    en: "Remove",
  },
  unexpectedError: {
    es: "Error inesperado",
    en: "Unexpected error",
  },
  inspectionForm: {
    es: "Fromulario de inspección",
    en: "Inspection form",
  },
  newInspectionType: {
    es: "Nueva versión creada correctamente para tipo de motor: [data{0}]",
    en: "New version successfully created for engine type: [data{0}]",
  },
  filesNotUploaded: {
    es: "Los ficheros [data{0}], no se han subido correctamente.",
    en: "The files [data{0}] were not uploaded correctly.",
  },
  canNotCreateInspection: {
    es: "No se puede abrir una inspección para un stand con número de serie [data{0}]. Por favor, comprueba que el dato es correcto.",
    en: "It is not possible to open an inspection for a car with serial number [data{0}]. Please check that the information is correct.",
  },
  phaseAction: {
    es: "Fases de la acción",
    en: "Phase action",
  },
  close: {
    es: "Cerrar",
    en: "Close",
  },
  of: {
    es: "de",
    en: "of",
  },
  sort: {
    es: "Ordenar",
    en: "Sort",
  },
  sortBy: {
    es: "Ordenar por",
    en: "Sort by",
  },
  ascending: {
    es: "Ascendente",
    en: "Ascending",
  },
  descending: {
    es: "Descendente",
    en: "Descending",
  },
  applySorting: {
    es: "Aplicar orden",
    en: "Apply sorting",
  },
  resertSorting: {
    es: "Resetear orden",
    en: "Resert sorting",
  },
  end: {
    es: "Finalización:",
    en: "End",
  },
  pdfDownloadSuccess: {
    es: "PDF desacargado correctamente",
    en: "succesfuly downloaded PDF",
  },
  importCsv: {
    es: "Importar CSV",
    en: "Import CSV",
  },
  importCsvSuccess: {
    es: "CSV importado con éxito",
    en: "CSV imported successfully",
  },
  userList: {
    es: "Listado de usuarios",
    en: "User list",
  },
  newUser: {
    es: "Nuevo usuario",
    en: "New user",
  },
  optionSelect: {
    es: "Seleccione una opción",
    en: "Select an option",
  },
  name: {
    es: "Nombre",
    en: "Name",
  },
  lastname: {
    es: "Apellido",
    en: "Last name",
  },
  email: {
    es: "Email",
    en: "Email",
  },
  role: {
    es: "Rol",
    en: "Role",
  },
  employeeId: {
    es: "Nómina",
    en: "Employee ID",
  },
  createUser: {
    es: "Crear usuario",
    en: "Create user",
  },
  editUser: {
    es: "Editar usuario",
    en: "Edit user",
  },
  userCreatedSuccessfully: {
    es: "Usuario creado con éxito",
    en: "User created successfully",
  },
  userEditedSuccessfully: {
    es: "Usuario editado con éxito",
    en: "User updated successfully",
  },
  creationDate: {
    es: "Fecha de alta",
    en: "Creation date",
  },
  deleteUser: {
    es: "Eliminar usuario",
    en: "Delete user",
  },
  deactivateUser: {
    es: "Desactivar usuario",
    en: "Deactivate user",
  },
  activateUser: {
    es: "Activar usuario",
    en: "Activate user",
  },
  active: {
    es: "Activo",
    en: "Active",
  },
  inactive: {
    es: "Inactivo",
    en: "Inactive",
  },
  areYouSureDeleteUser: {
    es: "¿Está seguro que desea eliminar al usuario [data{0}]?",
    en: "Are you sure you want to delete user [data{0}]?",
  },
  delete: {
    es: "Eliminar",
    en: "Delete",
  },
  userStatusUpdatedSuccessfully: {
    es: "Estado del usuario actualizado con éxito",
    en: "User status updated successfully",
  },
  fullname: {
    es: "Nombre completo",
    en: "Full name",
  },
  add: {
    es: "Añadir",
    en: "Add",
  },
  sameProjectText: {
    es: "No has cambiado el nombre de proyecto, si quieres mantenerlo cierra este formulario. En caso contrario, introduce uno nuevo.",
    en: "You haven’t changed the project name. If you’d like to keep it, just close this form. Otherwise, please enter a new name.",
  },
  sameProjectTitle: {
    es: "Revisa el nombre",
    en: "Check the",
  },
  addProject: {
    es: "Añade un proyecto",
    en: "Add a project",
  },
  changeProject: {
    es: "Cambia el proyecto",
    en: "Change the project",
  },
  user: {
    es: "Usuario",
    en: "User",
  },
  iberiaEmail: {
    es: "El correo debe ser de dominio iberia.",
    en: "The email address must be from the Iberia domain.",
  },
  importSharePoint: {
    es: "Importar SharePoint",
    en: "Import SharePoint",
  },
  importSharePointSuccess: {
    es: "SharePoint importado con éxito",
    en: "SharePoint imported successfully",
  },
};

export default literals;
